<fc-general-modal
  [baseId]="baseId"
  [form]="form"
  [fcModalItemContext]="fcModalItemContext"
  (saveForm)="save()"
  (cancelForm)="onCancel()"
>
  <div [formGroup]="form">
    <section class="flex-row-generic">
      <!-- External Id Control -->
      <div class="form-group flex-item-three-columns">
        <label
          for="{{ baseId }}-id"
          translate
        >ID</label>
        <input
          id="{{ baseId }}-id"
          class="form-control"
          [ngClass]="{ error: showErrors(externalIdControl, isSubmitted),'required': isRequired(externalIdControl) }"
          type="text"
          [maxlength]="fcListValidation.validations.ExternalID.MaxLength"
          [formControl]="externalIdControl"
        />
        <div
          *ngIf="showErrors(externalIdControl, isSubmitted)"
          id="{{ baseId }}-warning-text-id"
          class="incorrect-input"
          translate
        >
          {{ externalIdControl.errors | fcListValidation : 'ID' }}
        </div>
      </div>
      <!-- External Id Control -->

      <!-- Insurance Payer Control -->
      <div class="form-group flex-item-three-columns">
        <label for="{{ baseId }}-insurance-payer">Insurance Payer</label>
        <ap-findcontrol
          id="{{ baseId }}-insurance-payer"
          [baseId]="baseId"
          [apFormGroup]="form"
          controlName="insurancePayerControl"
          [findControlId]="FindControlIdService.ViewInsuranceCarrier"
          [(selectedPks)]="selectedInsurancePayerPks"
          [placeHolder]=""
          (chipsChange)="onInsurancePayerDataPopulate($event)"
          [disabled]="false"
          [singleSelect]="true"
          [findControlMaxLength]="100"
          findControlDisplayName="Find Insurance Payer"
          [required]="getFindControlValidation('CorporationUid')"
          (dirty)="insurancePayerControl.markAsDirty()"
          [formGroupSubmitted]="isSubmitted"
          [form]="form"
        >
        </ap-findcontrol>
      </div>
      <!-- Insurance Payer Control -->

      <!-- Insurance Plan Control -->
      <div class="form-group flex-item-three-columns">
        <label for="{{ baseId }}-insurance-plan">Insurance Plan</label>
        <ap-findcontrol
          id="{{ baseId }}-insurance-plan"
          [baseId]="baseId"
          [apFormGroup]="form"
          controlName="insurancePlanControl"
          [findControlId]="FindControlIdService.ViewPayerPlan"
          [(selectedPks)]="selectedInsurancePlanPks"
          [placeHolder]=""
          (chipsChange)="onInsurancePlanDataPopulate($event)"
          [disabled]="false"
          [singleSelect]="true"
          findControlDisplayName="Find Insurance Plan"
          [required]="getFindControlValidation('InsurancePlanUid')"
          (dirty)="insurancePlanControl.markAsDirty()"
          [formGroupSubmitted]="isSubmitted"
          [form]="form"
          [additionalSearchParameters]="insurancePlanAdditonalSearchParameters"
        >
        </ap-findcontrol>
      </div>
      <!-- Insurance Payer Control -->
    </section>

    <hr />
    <h4
      id="{{ baseId }}-name-details-subtitle"
      translate
    >Name Details</h4>

    <section class="flex-row-generic">
      <!-- Title Control -->
      <div class="form-group flex-item-three-columns">
        <label
          for="{{ baseId }}-title"
          translate
        >Title</label>
        <input
          id="{{ baseId }}-title"
          class="form-control"
          [ngClass]="{ error: showErrors(titleControl, isSubmitted), 'required': isRequired(titleControl) }"
          type="text"
          [maxlength]="fcListValidation.validations.Title.MaxLength"
          formControlName="title"
        />
        <div
          *ngIf="showErrors(titleControl, isSubmitted)"
          id="{{ baseId }}-warning-text-title"
          class="incorrect-input"
          translate
        >
          {{ titleControl.errors | fcListValidation : 'Title' }}
        </div>
      </div>
      <!-- Title Control -->

      <div class="form-group flex-item-three-columns">
        <label
          for="{{ baseId }}-first-name"
          translate
        >First Name</label>
        <input
          id="{{ baseId }}-first-name"
          class="form-control"
          [ngClass]="{ error: showErrors(firstNameControl, isSubmitted), 'required': isRequired(firstNameControl) }"
          type="text"
          [maxlength]="fcListValidation.validations.FirstName.MaxLength"
          formControlName="firstName"
        />
        <div
          *ngIf="showErrors(firstNameControl, isSubmitted)"
          id="{{ baseId }}-warning-text-first-name"
          class="incorrect-input"
          translate
        >
          {{ firstNameControl.errors | fcListValidation : 'First Name' }}
        </div>
      </div>

      <div class="form-group flex-item-three-columns">
        <label
          for="{{ baseId }}-middle-name"
          translate
        >Middle Name</label>
        <input
          id="{{ baseId }}-middle-name"
          class="form-control"
          [ngClass]="{ error: showErrors(middleNameControl, isSubmitted), 'required': isRequired(middleNameControl) }"
          type="text"
          [maxlength]="fcListValidation.validations.MiddleName.MaxLength"
          formControlName="middleName"
        />
        <div
          *ngIf="showErrors(middleNameControl, isSubmitted)"
          id="{{ baseId }}-warning-text-middle-name"
          class="incorrect-input"
          translate
        >
          {{ middleNameControl.errors | fcListValidation : 'Middle Name' }}
        </div>
      </div>

      <div class="form-group flex-item-three-columns">
        <label
          for="{{ baseId }}-last-name"
          translate
        >Last Name</label>
        <input
          id="{{ baseId }}-last-name"
          class="form-control"
          [ngClass]="{ error: showErrors(lastNameControl, isSubmitted), 'required': isRequired(lastNameControl) }"
          type="text"
          [maxlength]="fcListValidation.validations.LastName.MaxLength"
          formControlName="lastName"
        />
        <div
          *ngIf="showErrors(lastNameControl, isSubmitted)"
          id="{{ baseId }}-warning-text-last-name"
          class="incorrect-input"
          translate
        >
          {{ lastNameControl.errors | fcListValidation : 'Last Name' }}
        </div>
      </div>

      <div class="form-group flex-item-three-columns">
        <label
          for="{{ baseId }}-suffix"
          translate
        >Suffix</label>
        <input
          id="{{ baseId }}-suffix"
          class="form-control"
          [ngClass]="{ error: showErrors(suffixControl, isSubmitted), 'required': isRequired(suffixControl) }"
          type="text"
          [maxlength]="fcListValidation.validations.Suffix.MaxLength"
          formControlName="suffix"
        />
        <div
          *ngIf="showErrors(suffixControl, isSubmitted)"
          id="{{ baseId }}-warning-text-suffix"
          class="incorrect-input"
          translate
        >
          {{ suffixControl.errors | fcListValidation : 'Suffix' }}
        </div>
      </div>

      <div class="form-group flex-item-three-columns">
        <label
          for="{{ baseId }}-aka-first-name"
          translate
        >AKA First Name</label>
        <input
          id="{{ baseId }}-aka-first-name"
          class="form-control"
          [ngClass]="{ error: showErrors(akaFirstNameControl, isSubmitted), 'required': isRequired(akaFirstNameControl) }"
          type="text"
          [maxlength]="fcListValidation.validations.AkaFirstName.MaxLength"
          formControlName="akaFirstName"
        />
        <div
          *ngIf="showErrors(akaFirstNameControl, isSubmitted)"
          id="{{ baseId }}-warning-text-aka-first-name"
          class="incorrect-input"
          translate
        >
          {{ akaFirstNameControl.errors | fcListValidation : 'AKA First Name' }}
        </div>
      </div>

      <div class="form-group flex-item-three-columns">
        <label
          for="{{ baseId }}-last-name"
          translate
        >AKA Last Name</label>
        <input
          id="{{ baseId }}-last-name"
          class="form-control"
          [ngClass]="{ error: showErrors(akaLastNameControl, isSubmitted), 'required': isRequired(akaLastNameControl) }"
          type="text"
          [maxlength]="fcListValidation.validations.AkaLastName.MaxLength"
          formControlName="akaLastName"
        />
        <div
          *ngIf="showErrors(akaLastNameControl, isSubmitted)"
          id="{{ baseId }}-warning-text-aka-last-name"
          class="incorrect-input"
          translate
        >
          {{ akaLastNameControl.errors | fcListValidation : 'AKA Last Name' }}
        </div>
      </div>

      <div class="form-group flex-item-three-columns">
        <label for="{{ baseId }}-gender">Gender</label>
        <ap-findcontrol
          id="{{ baseId }}-gender"
          [baseId]="baseId"
          [apFormGroup]="form"
          controlName="genderControl"
          [findControlId]="FindControlIdService.ListGender"
          [(selectedPks)]="selectedGenderPks"
          [placeHolder]=""
          (chipsChange)="onGenderDataPopulate($event)"
          [disabled]="false"
          [singleSelect]="true"
          [findControlMaxLength]="50"
          findControlDisplayName="Find Gender"
          [required]="getFindControlValidation('GenderUid')"
          (dirty)="genderControl.markAsDirty()"
          [formGroupSubmitted]="isSubmitted"
          [form]="form"
        >
        </ap-findcontrol>
      </div>
    </section>

    <hr />
    <h4
      id="{{ baseId }}-contact-information-subtitle"
      translate
    >Contact Information</h4>

    <!-- Contact Information Group -->
    <section class="contact-information">
      <fc-phone-number-list
      [baseId]="baseId"
      [form]="phoneOneGroup"
      [listItem]="listItem.Phone1"
      [isSubmitted]="isSubmitted"
      [itemContext]="fcModalItemContext"
      [index]="1"
      ></fc-phone-number-list>
      <fc-phone-number-list
      [baseId]="baseId"
      [form]="phoneTwoGroup"
      [listItem]="listItem.Phone2"
      [isSubmitted]="isSubmitted"
      [itemContext]="fcModalItemContext"
      [index]="2"
      ></fc-phone-number-list>
      <div class="flex-row-generic">
        <div class="form-group flex-item-two-columns">
          <label
          for="{{ baseId }}-email-one"
          translate
          >Email 1</label>
          <input
          id="{{ baseId }}-email-one"
          class="form-control"
          [ngClass]="{ error: showErrors(emailOneControl, isSubmitted), 'required': isRequired(emailOneControl) }"
          type="text"
          [maxlength]="fcListValidation.validations.Email.MaxLength"
          formControlName="emailOne"
          />
          <div
          *ngIf="showErrors(emailOneControl, isSubmitted)"
          id="{{ baseId }}-warning-text-email-one"
          class="incorrect-input"
          translate
          >
          {{ emailOneControl.errors | fcListValidation : 'Email 1' }}
        </div>
      </div>

      <div class="form-group flex-item-two-columns">
        <label
        for="{{ baseId }}-email-two"
        translate
        >Email 2</label>
        <input
        id="{{ baseId }}-email-two"
        class="form-control"
        [ngClass]="{ error: showErrors(emailTwoControl, isSubmitted), 'required': isRequired(emailTwoControl) }"
        type="text"
        [maxlength]="fcListValidation.validations.Email.MaxLength"
        formControlName="emailTwo"
        />
        <div
        *ngIf="showErrors(emailTwoControl, isSubmitted)"
        id="{{ baseId }}-warning-text-email-two"
        class="incorrect-input"
        translate
        >
        {{ emailTwoControl.errors | fcListValidation : 'Email 2' }}
      </div>
    </div>
  </div>
</section>
    <!-- Contact Information Group -->

    <div class="form-group full-control">
      <label
        for="{{ baseId }}-notes"
        translate
      >Notes</label>
      <textarea
        class="form-control"
        [ngClass]="{ error: showErrors(notesControl, isSubmitted), 'required': isRequired(notesControl) }"
        id="{{ baseId }}-notes"
        [maxlength]="fcListValidation.validations.Notes.MaxLength"
        formControlName="notes"
        rows="3"
      >
      </textarea>
      <div
        *ngIf="showErrors(notesControl, isSubmitted)"
        id="{{ baseId }}-warning-text-insurance-contact-notes"
        class="incorrect-input"
        translate
      >
        {{ notesControl.errors | fcListValidation : 'Notes' }}
      </div>
    </div>

    <div class="checkbox-group">
      <mat-checkbox
        id="{{ baseId }}-inactive-checkbox"
        formControlName="inactive"
        translate
      > Inactive </mat-checkbox>
    </div>
  </div>
</fc-general-modal>
